import { createUserManager } from 'redux-oidc';

const authority = process.env.REACT_APP_LOGIN_AUTHORITY;
const silentRenewUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/silent_auth_renew`;
const userManagerConfig = {
  authority,
  client_id: 'charitable.spa',
  response_type: 'code',
  scope: 'openid profile charitable.api api1',
  redirect_uri: process.env.REACT_APP_LOGIN_REDIRECT,
  post_logout_redirect_uri: process.env.REACT_APP_LOGOUT_REDIRECT,
  automaticSilentRenew: false,
  accessTokenExpiringNotificationTime: 120,
  silent_redirect_uri: silentRenewUrl,
  includeIdTokenInSilentRenew: true
};

const userManager = createUserManager(userManagerConfig);

export default userManager;
